module.exports = __webpack_public_path__ + "static/img/short04.83691c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/short04.png
// module id = lxOn
// module chunks = 0